import React, { useEffect, useState } from "react";
import { Sparkles, Gift, X } from "lucide-react";
import { api } from "../lib/api";

// Slim above-the-fold announcement strip. Surfaces BOTH the founder offer
// and the referral hook so neither gets buried. Stacks on mobile (two lines)
// and goes inline on desktop. Auto-hides when the founder window closes or
// the user dismisses.
const DISMISS_KEY = "fff_founder_strip_dismissed";

const FounderStrip = () => {
  const [eb, setEb] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    try { setDismissed(localStorage.getItem(DISMISS_KEY) === "1"); } catch { /* ignore */ }
    api.earlybirdStatus().then(setEb).catch(() => {});
  }, []);

  if (dismissed || !eb || !eb.available) return null;
  const spotsLeft = eb.spots_left ?? 0;

  const scrollToPricing = () => {
    const el = document.getElementById("pricing");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const dismiss = (e) => {
    e.stopPropagation();
    try { localStorage.setItem(DISMISS_KEY, "1"); } catch { /* ignore */ }
    setDismissed(true);
  };

  return (
    <div
      data-testid="founder-strip"
      className="relative w-full bg-gradient-to-r from-[#BEFF38] via-[#a6e62e] to-[#BEFF38] text-black"
    >
      <button
        type="button"
        onClick={scrollToPricing}
        data-testid="founder-strip-cta"
        className="w-full hover:brightness-105 transition-all"
      >
        <div className="max-w-[1180px] mx-auto px-4 sm:px-8 py-2 flex flex-col sm:flex-row sm:items-center sm:justify-center gap-1 sm:gap-3 text-[11px] sm:text-xs font-bold tracking-wide">
          {/* Line 1: founder offer */}
          <span
            data-testid="founder-strip-founder"
            className="inline-flex items-center justify-center gap-1.5"
          >
            <Sparkles className="w-3.5 h-3.5 shrink-0" />
            <span className="uppercase font-black">
              Founder · £19/year · {spotsLeft}/100 left
            </span>
          </span>

          {/* Line 2: referral offer — visible on every screen size */}
          <span
            data-testid="founder-strip-referral"
            className="inline-flex items-center justify-center gap-1.5"
          >
            <Gift className="w-3.5 h-3.5 shrink-0" />
            <span className="font-semibold">
              Refer a friend &middot; get 2 months free
            </span>
          </span>

          <span
            className="inline-flex items-center justify-center self-center px-2 py-0.5 rounded-full bg-black/15 uppercase tracking-wider font-black text-[10px] sm:text-xs"
          >
            See pricing &rarr;
          </span>
        </div>
      </button>

      <button
        type="button"
        onClick={dismiss}
        aria-label="Dismiss founder offer"
        data-testid="founder-strip-dismiss"
        className="absolute top-1 right-2 sm:top-1/2 sm:-translate-y-1/2 sm:right-3 p-1 rounded-full hover:bg-black/10"
      >
        <X className="w-3.5 h-3.5 opacity-60" />
      </button>
    </div>
  );
};

export default FounderStrip;
